import React from 'react'
import { InlineDisplayContent } from '@ztechapps/webui.input'
import { ProjectSelect } from '../ProjectSelect'
import { useTasksPerProjectContext } from './Context'
import { TaskList } from './TaskList'
import { ProjectStatusEnum } from '@ztechapps/common.contract'
import { Stack } from 'react-bootstrap'

export const Layout = () => {
  const { setActiveProject } = useTasksPerProjectContext()

  return (
    <Stack gap={2}>
      <InlineDisplayContent label={'Choose a Project'}>
        <ProjectSelect
          onChange={setActiveProject}
          filter={{
            $or: [{ status: ProjectStatusEnum.Draft }, { status: ProjectStatusEnum.InProgress }],
            'tasks.0': { $exists: true },
          }}
        />
      </InlineDisplayContent>

      <TaskList />
    </Stack>
  )
}
